export default __webpack_public_path__ + "static/media/zero-state-default.4e4cc215.svg";